import { createContext, type Dispatch } from 'react';
import type { GlobalState, GlobalStateAction } from './globalState';

export interface GlobalContextValue {
  state: GlobalState;
  dispatch: Dispatch<GlobalStateAction>;
}

export const GlobalContext = createContext<GlobalContextValue | undefined>(undefined);
